module.exports = __webpack_public_path__ + "static/media/(000010).c1e4dafa.jpg";